import type { ComponentProps } from "./banner.d";
import "./banner.scss";

import React, { useEffect } from "react";

import { useAppStore } from "../../../react4xp/shared/stores";

function Component(props: ComponentProps) {
	const { items } = props;

	const appStore = useAppStore((state) => state);
	const appStoreUpdate = useAppStore((state) => state.update);

	useEffect(() => {
		appStoreUpdate({ isHeaderTransparent: true });
	}, [appStoreUpdate]);

	return (
		<section className={`banner`}>
			{items.hits.length > 0 && (
				<div className="banner-img" style={{ backgroundImage: `url("${items.hits[0].data.contentTypeImage ?? ""}")` }}>
					<div className="overlay">
						<div className="container">
							<h1 className="title text-light text-uppercase">
								{items.hits[0].displayName} <br />
								{items.hits[0].data.subtitle}
							</h1>
							<p>{items.hits[0].data.description}</p>
							{items.hits[0].data.link && (
								<a className="btn btn-primary" href={items.hits[0].data.link}>
									{appStore.phrases?.["moreDetails"]}
									<i className="fa-solid fa-arrow-right-long"></i>
								</a>
							)}
						</div>
					</div>
				</div>
			)}

			{items.hits.length === 0 && (
				<div className="empty text-light m-auto">
					<h3>{appStore.phrases?.["empty"]}</h3>
				</div>
			)}
		</section>
	);
}

export default function WrappedComponent(props: ComponentProps) {
	return <Component {...props} />;
}
